import { AppliedFilter, FilterArrayItem, TabItem } from '../types';

export function makeCreatedAtDefaults(days: number) {
  const end = new Date();
  const start = new Date();
  start.setDate(end.getDate() - days);

  const toYmd = (d: Date) =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(
      d.getDate()
    ).padStart(2, '0')}`;

  const startStr = toYmd(start);
  const endStr = toYmd(end);

  const label = `Last ${days} days`;
  const id = JSON.stringify({ period: label });

  const appliedFilters: AppliedFilter[] = [
    {
      id,
      name: `Created date: ${label}`,
      dateFilter: 'created_at',
      start: startStr,
      end: endStr,
      period: label,
    },
  ];

  const filterArray: FilterArrayItem[] = [
    { filterBy: 'created_at', filterValue: [id] },
  ];

  return { appliedFilters, filterArray };
}

const DEFAULT_LAST_DAYS = 7;
const createdAtDefaults = makeCreatedAtDefaults(DEFAULT_LAST_DAYS);

export const makeDefaultSheet = (val: number): TabItem => ({
  id: null,
  sheet_name: `Tab ${val + 1}`,
  editing: false,
  hasMore: true,
  page: 1,
  filters: {
    appliedFilters: [...createdAtDefaults.appliedFilters],
    filterArray: [...createdAtDefaults.filterArray],
  },
  headers: [],
  data: [],
  created_at: '',
  created_by: '',
  updated_at: '',
  updated_by: '',
  preset: '',
});
